<template>
  <v-menu
    v-model="menuCardType[card.id]"
    :disabled="$store.state.isWorkflowDisabled"
    style="z-index: 9999;"
    scrim="true"
  >
    <template v-slot:activator="{ props }">
      <i
        v-if="small"
        class="pa-0 mx-1 rounded add-card-of-type"
        :class="{ 'show-on-hover': showOnHover }"
        @click="!$store.state.isWorkflowDisabled && openSelector(card)"
        :style="{ background: getCardBackgroundColour(card.cardType) }"
        v-bind="props"
      >
      </i>
      <v-btn
        v-else
        :tabindex="tabIndex"
        @click="props.onClick"
        variant="flat"
        size="small"
        @keydown="!$store.state.isWorkflowDisabled && handleKeydown($event, props.onKeydown)"
        class="status-button card-type"
        :class="{ 'show-on-hover': showOnHover }"
        :style="{backgroundColor: `${backgroundColor}!important`}"
        :id="`card-type-button-${card.id}`"
      >
        <div style="text-transform: none; text-align: left" class="btn">
          <template v-if="card.cardType && cardTypeExists(card.cardType)">
            {{ card.cardType.title }} <v-icon>mds:arrow_drop_down</v-icon>
          </template>
          <template v-else>
            <v-icon size="small">mdi-dots-horizontal  </v-icon>
          </template>
        </div>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="cardType in filteredRequirementTypes"
        :key="cardType.id"
        @click="changeCardType(card, cardType.id)"
        prepend-icon="card-type-icon"
      >
        <template v-slot:prepend>
          <i
            class="pa-0 mr-2 rounded add-card-of-type"
            :style="{ background: getCardBackgroundColour(cardType) }"
          >
          </i>
        </template>
        <v-list-item-action>
          {{ cardType.title }}
        </v-list-item-action>
      </v-list-item>
      <!-- TODO: this is broken it seems -->
      <!-- <v-list-item @click="changeCardType(card, null)">
        <v-list-item-action>
          <v-icon size="small">mdi-dots-horizontal</v-icon>
        </v-list-item-action>
      </v-list-item> -->
      <v-list-item @click="openTypeSettings">
        <v-list-item-action>
          <v-icon size="small" class="mr-2">mdi-pencil</v-icon> Edit card types
        </v-list-item-action>
      </v-list-item>

    </v-list>
  </v-menu>
</template>

<script>
import requirementTypesApi from '@/api/requirementTypesApi'
import workflowApi from '@/api/workflowApi'
import { EventBus } from '@/event-bus/event-bus.js'
import { mapState } from 'vuex'

export default {
  props: {
    card: Object,
    tabIndex: Number,
    small: Boolean,
    showOnHover: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuCardType: {} // keep track of if a certain menu is open
    }
  },
  computed: {
    ...mapState({
      requirementTypes: state => state.requirementTypes.requirementTypes
    }),
    filteredRequirementTypes () {
      return this.requirementTypes.filter(requirementType => !requirementType.triggerType && !requirementType.aggregateType)
    },
    backgroundColor () {
      const color = this.card?.cardType?.color
      return (color && `rgb(${color.red},${color.green},${color.blue})`) || '#363A40'
    }
  },
  methods: {
    handleKeydown (event, fallback) {
      if (event.keyCode === 27) {
        this.menuCardType[this.card.id] = false
        return
      }
      // if key code Enter then don't call the fallback
      if (event.keyCode === 13) {
        return
      }
      if (!this.menuCardType[this.card.id]) {
        this.$emit('keydown-card-type', event)
      } else {
        fallback(event)
      }
    },
    getCardBackgroundColour (cardType) {
      return requirementTypesApi.getBackgroundColour(cardType)
    },
    getCardTextColour (cardType) {
      return requirementTypesApi.getTextColour(cardType)
    },
    cardTypeExists (cardType) {
      const res = requirementTypesApi.cardTypeExists(cardType)
      return res
    },
    async changeCardType (item, cardTypeId) {
      if (item.cardTypeId === cardTypeId) {
        return
      }

      this.menuCardType[this.card.id] = false
      await workflowApi.updateRequirementsJsonMutation(this.$route.params.id, [{
        requirementId: item.id,
        cardTypeId,
        updateNote: {
          action: 'changed card type of',
          target: item.description
        }
      }])
      // if we are in the backlog (not small) then set the focus back to the button
      if (!this.small) {
        this.$nextTick(() => {
          document.getElementById(`card-type-button-${this.card.id}`)?.focus()
        })
      }
    },
    openSelector () {
      this.menuCardType[this.card.id] = true
    },
    openTypeSettings () {
      this.menuCardType[this.card.id] = false
      EventBus.$emit('open-types-settings', 'CARDS')
    }
  }
}
</script>

<style scoped>
.v-btn.status-button {
  margin-left: 0;
  margin-right: 0;
  min-width: 40px;
  padding: 5px 8px 5px 12px !important
}

.add-card-of-type {
  width: 14px;
  height: 14px;
  cursor: move;
}
</style>
